export interface SurveyRecord {
	id: number;
	dateOfSale: Date;
	dispositionDate?: Date;
	enrollmentId?: number;
	saleId: string;
	stateName: string;
	brandName: string;
	channelName: string;
	marketerName: string;
	branchName: string;
	repLogin: string;
	repId: number;
	repFirstName: string;
	repLastName: string;
	customerFirstName: string;
	customerLastName: string;
	enrollmentStatus: string;
	agentCourteous: string;
	choseSupplier: string;
	rememberSigning: string;
	noticeOfCancellation: string;
	dirtyClean: string;
	rating: string | null;
	comments: string;
	status: SurveyStatus;
	createdOn: Date;
	responses: SurveyResponse[];
}

export interface SurveyResponse {
	surveyResponseId: number;
	questionTag: string;
	value: string;
}

export enum SurveyStatus {
	AVL_Error = -99,
	DeclinedSMSConsent = -4,
	InvalidPhoneNumber = -3,
	VOIP = -2,
	Landline = -1,
	Incoming = 0,
	Completed = 1,
	Undeliverable = 2,
	LinkExpired = 3,
	AnswerTimeout = 4,
	DeclinedSurvey = 5,
}

export interface SurveyResults {
	good: number;
	total: number;
	avgRating: number;
}
